/*
 * サブシステム名：OTM受付一覧編集
 * 機能名：受付一覧編集
 */
import flowMixin from '@/mixins/flowMixins'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'

import filter from '@/rahmen/utils/filters'
import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'

// import { mapGetters } from 'vuex'
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox.vue')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdSwitch = () => import('@/components/DdSwitch')
const DdTimeBox = () => import('@/components/DdTimeBox')
const DdTimeRangeBox = () => import('@/components/DdTimeRangeBox')
const DdTextArea = () => import('@/components/DdTextArea')

export default {
  name: 'OtmScheduler',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCheckbox,
    DdCodeTextBox,
    DdDateBox,
    DdDropDown,
    DdEditCommonBar,
    DdNumericBox,
    DdSubHeader,
    DdSwitch,
    DdTimeBox,
    DdTimeRangeBox,
    DdTextArea
  },
  data: () => ({
    id: null,
    viewTitleX: '労務管理',
    viewsData: {
      vwUnkoJisseki: {},
      vwKinmuJisseki: {},
      vwKintaiJisseki: [],
      vwManageInfo: {}
    },
    baseYmd: null,

    // 内部処理用
    targetCountLists: [1, 2, 3, 4, 5],
    weekDayStrJP: ['日', '月', '火', '水', '木', '金', '土'],

    // ----------------------------------------------------------------------------------------------------
    // オートコンプリート定義
    // ----------------------------------------------------------------------------------------------------
    mstJininHeaders: header.mstJininHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,

    // 制御用
    modeKengen: 0
  }),
  watch: {
    conditions: {
      handler: function (s) {
        if (![undefined, null, ''].includes(s.baseYmd)) {
          this.setShowTarget()
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'users/helpUseFlg',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      sharyoList: 'DDMasters/vwCMstSharyo',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg'
    }),

    // 人員マスタフィルタ
    filteredVwcMstJinin () {
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredJishaJininList () {
      const self = this
      return this.filteredVwcMstJinin.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.eigyoshoKbn !== '03'
      })
    },

    // 車両マスタフィルタ
    filteredMstSharyo () {
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstSharyoList () {
      const self = this
      return this.filteredMstSharyo.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.hacchusakiFlg === false
      })
    },

    // 作業種別
    filteredSagyoSbtList () {
      var itemList = []
      itemList.push({ value: null, text: '未選択' })
      itemList.push({ value: '01', text: '運転手' })
      itemList.push({ value: '02', text: '作業員' })
      return itemList
    },
    filteredKasanJikyuSbtList () {
      var itemList = []
      return itemList
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  methods: {
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['vwcmsteigyoshojininlist', 'vwcmstsharyo'],
        defineHeaderPromise: () => {
          return new Promise((resolve) => {
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initSettings()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            resolve()
          })
        },
        researchPromise: (c) => {
          console.log('OtmDeliveryLedger.researchPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('OtmDeliveryLedger.restoreViewPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('OtmDeliveryLedger.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    initSettings: function () {
      this.id = 0
      this.baseYmd = date.getCurrentDate()
      this.viewsData.vwUnkoJisseki.unkoYmd = this.baseYmd
      this.viewsData.vwKinmuJisseki.shukkoYmd = this.baseYmd

      this.viewsData.vwKintaiJisseki.push(
        { id: 1, sagyoKbn: '01', sagyoKbnNm: '運転手', jininId: null, shukkinHms: null, taikinHms: null },
        { id: 2, sagyoKbn: '02', sagyoKbnNm: '作業員', jininId: null, shukkinHms: null, taikinHms: null }
      )
    },

    /**
     * ボタンイベント
     */
    onReturnButtonClick: function () {
    },
    onAddTantoshaClick: function () {
      const tmp = {
        id: -1,
        sagyoKbn: null,
        sagyoKbnNm: null,
        jininId: null,
        shukkinHms: null,
        taikinHms: null
      }
      this.viewsData.vwKintaiJisseki.push(tmp)
      this.viewsData.vwKintaiJisseki.splice()
    },

    getWeekDay: function (d) {
      var dx = dayjs(d)
      return '(' + this.weekDayStrJP[dx.day()] + ')'
    },
    row_color_class: function (item) {
      if (item.memo4.indexOf('比嘉') >= 0) {
        return 'orange-event'
      } else if (item.memo4.indexOf('又吉') >= 0) {
        return 'yellow-event'
      }

      return ''
    },

    onDummyFunction: function () {
    }
  }
}
